import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormShortPDFNoBackground } from '../../../components/DemoFormShortPDFNoBackground.jsx';
import MultimedialPanel from '../../../components/MultimedialPanel';


const PeoplePioneers2022 = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;


    return (
        <Layout bodyClass="people-pioneers-2022" ontouchstart>
            <SEO title="2022 People Pioneers: Honoring HR Leaders Paving the Way Forward | Resources | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="The 2022 People Pioneers Award recognizes HR leaders who have positively impacted their companies in new and creative ways to ease friction and overcome unique challenges."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="2022 People Pioneers: Honoring HR Leaders Paving the Way Forward" />
                <meta property="og:description" content="The 2022 People Pioneers Award recognizes HR leaders who have positively impacted their companies in new and creative ways to ease friction and overcome unique challenges." />
                <meta property="og:image" content={`https://www.charthop.com/resources/guides-ebooks/people-pioneer/MetaImage.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="2022 People Pioneers: Honoring HR Leaders Paving the Way Forward" />
                <meta name="twitter:description" content="The 2022 People Pioneers Award recognizes HR leaders who have positively impacted their companies in new and creative ways to ease friction and overcome unique challenges." />
                <meta name="twitter:image" content={`https://www.charthop.com/resources/guides-ebooks/people-pioneer/MetaImage.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HEADER h4*/}
            <section className="hero-dei-reporting">
                <div className="row bottom-formPDF sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12 text-left padding-left-headerContent">
                        <h1 className="h1-correct">
                            2022 People Pioneers: Honoring HR Leaders Paving the Way Forward
                        </h1>
                    </div>
                </div>
                <div className="top-formPDF sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormShortPDFNoBackground pdfUrl={'/resources/guides-ebooks/people-pioneer/Charthop_People-Pioneers-Winners-Magazine_PDF.pdf'} source={"resources-People-Pioneers-2022-Winners-2022-PDF-contentdownload-header"} />
                </div>
            </section>

            <section className="sectionSpacing flex-centeredColumn dei-section">
                <div className="contentBlock">
                    <div className="flex-centeredColumn contentBlock">
                        <p className="text-center my-2 planForwardSubTitle">
                            The 2022 People Pioneers Award recognizes HR leaders who have positively impacted their companies and employees in new and creative ways to ease friction and overcome the unique challenges presented by the complete uncertainty of the past two years.
                        </p>
                        <p className="text-center my-2 planForwardSubTitle">
                            The winners of this award confidently led their companies through critical initiatives to grow the business, attract and retain top talent, and support employee well-being. To do so, they led efforts that cover everything from ensuring pay equity and creating more diverse hiring practices to revamping benefits in a pandemic-driven world and coaching executive team members.
                        </p>
                    </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer testimonial-container pt-8 pb-5 backgroundGradientContainer">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>

  

  
            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
                <DemoFormLong source={"resources-startup-people-leader-checklist-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"I value ChartHop so much as a People leader. The system is comprehensive, the UI is intuitive and the workflow is clean and logical. Unlike many other HR systems, there is no selling required to yield internal adoption. Once my business owners were provided access and given a tour of the dashboards we built for them, they were hooked."</p><div class="authorTag"><img src="/resources/guides-ebooks/startup-people-leader-checklist/kyle-roberts_even-th.jpg" class="testimonialAuthor" alt="Kyle Roberts" /><div><p class="contactAuthor"><strong>Kyle Roberts</strong> <br>Chief People Officer, Even Financial</p></div></div>')}/>
            </section>


        </Layout>
    );
};


export default PeoplePioneers2022;

export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;